window.PimV2PricingUi = {
  init() {
    const showPromoPriceElement = document.getElementById("shopify-show-promo-price");
    const titleElement = document.querySelector(".product__title h1");
    const productTypeElement = document.getElementById("shopify-product-type");
    const regularPriceElement = document.querySelector(".price-item.price-item--regular.pdp-price");
    const isPreSaleProductElement = document.getElementById("shopify-is-presale-product");
    const productTypeInput = document.getElementById("imp-product-type");
    const dealsCrafterConfigElement = document.getElementById("shopify-deals-crafter-config");
    const productVariantIdElement = document.querySelector('input[name="id"]');

    if (
      !showPromoPriceElement ||
      !titleElement ||
      !productTypeElement ||
      !regularPriceElement ||
      !isPreSaleProductElement ||
      !dealsCrafterConfigElement ||
      !productVariantIdElement
    ) {
      console.error(
        "[PDP Init] Missing required DOM elements for pricing initialization."
      );
      updateTotalAddCart();
      return;
    }

    const showPromoPrice = showPromoPriceElement.value;
    const productType = productTypeElement.value;
    const isPreSaleProduct = isPreSaleProductElement.value;
    const productVariantId = productVariantIdElement.value;

    const isPreSaleProductEnabled =
      String(isPreSaleProduct).toLowerCase() === "true";

    const isPreSaleContext =
      global_configs.isPreSaleEnabled && isPreSaleProductEnabled;

    let dealsCrafterConfig = {};

    try {
      const configValue = dealsCrafterConfigElement.value.trim();

      if (configValue) {
        dealsCrafterConfig = JSON.parse(configValue);
      }
    } catch (error) {
      dealsCrafterConfig = {};
    }

    addPdpFilterPromoBadges();

    /*
     * Mark the cart line as Pre-Sale when the current PDP
     * is operating in a Pre-Sale context.
     */
    if (isPreSaleContext) {
      const presaleInput = document.getElementById("imp-pre-sale-input");

      if (presaleInput) {
        presaleInput.value = "true";
      }
    }

    /*
     * Update the discount badge for the current variant.
     */
    if (showPromoPrice !== "true") {
      if (isPreSaleContext) {
        updateDiscountBadge(
          productVariantId,
          dealsCrafterConfig,
          "presale"
        );
      } else {
        updateDiscountBadge(
          productVariantId,
          dealsCrafterConfig
        );
      }

      /*
       * When discounts are configured at variant level,
       * update the badge every time the selected variant changes.
       */
      this.setupVariantDiscountBadgeListener(
        dealsCrafterConfig,
        isPreSaleContext
      );

      updateTotalAddCart();
      return;
    }

    if (productTypeInput) {
      productTypeInput.value = productType;
    }

    const htmlPrice = regularPriceElement.textContent;

    const discountedPrice = isPreSaleContext
      ? getDiscountedPrice(
          productVariantId,
          htmlPrice,
          dealsCrafterConfig,
          "presale"
        )
      : getDiscountedPrice(
          productVariantId,
          htmlPrice,
          dealsCrafterConfig,
          "normal"
        );

    const badgeCopy = isPreSaleContext
      ? global_configs._pre_sale_label
      : "On Sale";

    window.PimV2PricingUi.renderPdpDiscountedPrice(
      regularPriceElement,
      htmlPrice,
      discountedPrice,
      badgeCopy
    );

    /*
     * Even when the promotional price is displayed, keep the
     * variant badge synchronized when using variant discounts.
     */
    this.setupVariantDiscountBadgeListener(
      dealsCrafterConfig,
      isPreSaleContext
    );

    updateTotalAddCart();
  },

  /**
   * Sets up the listener responsible for updating the discount badge
   * whenever the selected product variant changes.
   *
   * The listener is only required when the active DealsCrafter
   * discount mode is "variant".
   *
   * For Pre-Sale products, preSaleMode determines whether the
   * discount is product-level or variant-level.
   *
   * @param {Object} dealsCrafterConfig - DealsCrafter V2 product configuration.
   * @param {boolean} isPreSaleContext - Whether the PDP is currently in Pre-Sale context.
   * @returns {void}
   */
  setupVariantDiscountBadgeListener(
    dealsCrafterConfig,
    isPreSaleContext = false
  ) {
    const variantIdElement = document.querySelector('input[name="id"]');

    if (!variantIdElement || !dealsCrafterConfig) {
      return;
    }

    /*
     * Determine which mode controls the current badge.
     */
    const discountMode = isPreSaleContext
      ? dealsCrafterConfig.preSaleMode
      : dealsCrafterConfig.mode;

    /*
     * Product-level discounts are the same for every variant,
     * so there is no need to listen for variant changes.
     */
    if (discountMode !== "variant") {
      return;
    }

    /*
     * Avoid registering the same listener multiple times
     * if init() is called more than once.
     */
    if (variantIdElement.dataset.discountBadgeListenerAttached === "true") {
      return;
    }

    variantIdElement.dataset.discountBadgeListenerAttached = "true";

    variantIdElement.addEventListener("change", () => {
      const variantId = variantIdElement.value;

      if (!variantId) {
        return;
      }

      const showPromoPrice = document.getElementById(
        "shopify-show-promo-price"
      )?.value;

      if (showPromoPrice === "true") {
        setStartingAtPriceOnPDP();
      } else if (isPreSaleContext) {
        updateDiscountBadge(
          variantId,
          dealsCrafterConfig,
          "presale"
        );
      } else {
        updateDiscountBadge(
          variantId,
          dealsCrafterConfig,
          "normal"
        );
      }

      addPromoBadgesToPDPGallery();
    });
  },

  setStartingAtPriceOnPDP() {
    const showPromoPriceElement = document.getElementById("shopify-show-promo-price");
    const titleElement = document.querySelector(".product__title h1");
    const salePriceElement = document.querySelector(".price-item.price-item--sale.price-item--last.pdp-price");
    const regularPriceElement = document.querySelector(".price-item.price-item--regular.pdp-price");
    const isPreSaleProductElement = document.getElementById("shopify-is-presale-product");
    const dealsCrafterConfigElement = document.getElementById("shopify-deals-crafter-config");
    const variantIdElement = document.querySelector('input[name="id"]');

    if (
      !showPromoPriceElement ||
      !titleElement ||
      !salePriceElement ||
      !regularPriceElement ||
      !isPreSaleProductElement ||
      !dealsCrafterConfigElement ||
      !variantIdElement
    ) {
      console.error(
        "[setStartingAtPriceOnPDP] Missing required DOM elements."
      );
      return;
    }

    const showPromoPrice = showPromoPriceElement.value;
    const isPreSaleProduct = isPreSaleProductElement.value;

    const isPreSaleProductEnabled =
      String(isPreSaleProduct).toLowerCase() === "true";

    const isPreSaleContext =
      global_configs.isPreSaleEnabled && isPreSaleProductEnabled;

    let dealsCrafterConfig = {};

    try {
      const configValue = dealsCrafterConfigElement.value.trim();

      if (configValue) {
        dealsCrafterConfig = JSON.parse(configValue);
      }
    } catch (error) {
      dealsCrafterConfig = {};
    }

    const productVariantId = variantIdElement.value;

    if (showPromoPrice !== "true") {
      if (isPreSaleContext) {
        updateDiscountBadge(
          productVariantId,
          dealsCrafterConfig,
          "presale"
        );
      } else {
        updateDiscountBadge(
          productVariantId,
          dealsCrafterConfig,
          "normal"
        );
      }

      this.setupVariantDiscountBadgeListener(
        dealsCrafterConfig,
        isPreSaleContext
      );

      return;
    }

    const htmlPrice = salePriceElement.textContent;

    const discountedPrice = isPreSaleContext
      ? getDiscountedPrice(
          productVariantId,
          htmlPrice,
          dealsCrafterConfig,
          "presale"
        )
      : getDiscountedPrice(
          productVariantId,
          htmlPrice,
          dealsCrafterConfig,
          "normal"
        );

    const badgeCopy = isPreSaleContext
      ? global_configs._pre_sale_label
      : "On Sale";

    window.PimV2PricingUi.renderPdpDiscountedPrice(
      regularPriceElement,
      htmlPrice,
      discountedPrice,
      badgeCopy
    );

    this.setupVariantDiscountBadgeListener(
      dealsCrafterConfig,
      isPreSaleContext
    );
  },

  isEmptyDiscountPrice(value) {
    return value === null || value === undefined || value === "";
  },

  getOrCreatePdpPriceBadge(parentElement) {
    if (!parentElement) return null;

    let badgeElement = parentElement.querySelector(
      ".pim-v2-price-badge"
    );

    if (!badgeElement) {
      badgeElement = document.createElement("span");
      badgeElement.className = "badge pim-v2-price-badge";
      badgeElement.style.backgroundColor = "var(--orange)";
      badgeElement.style.color = "white";
      badgeElement.style.marginLeft = "10px";
      parentElement.appendChild(badgeElement);
    }

    return badgeElement;
  },

  renderPdpDiscountedPrice(
    priceElement,
    htmlPrice,
    discountedPrice,
    badgeCopy
  ) {
    if (!priceElement) return;

    if (this.isEmptyDiscountPrice(discountedPrice)) {
      priceElement.parentNode
        ?.querySelector(".pim-v2-price-badge")
        ?.remove();
      priceElement.innerHTML = `${htmlPrice}`;
      return;
    }

    priceElement.innerHTML =
      `${discountedPrice} ` +
      `<strike style="color:gray; font-size:20px; font-weight: 300;" data-class="is-showing">` +
      `${htmlPrice}` +
      `</strike>`;

    const badgeElement = this.getOrCreatePdpPriceBadge(
      priceElement.parentNode
    );

    if (badgeElement) {
      badgeElement.innerHTML = badgeCopy;
    }
  }
};

window.setStartingAtPriceOnPDP =
  window.PimV2PricingUi.setStartingAtPriceOnPDP.bind(window.PimV2PricingUi);